export default function InfeasibilityReasons(props) {
  const infeasibility_reasons = props.reasons.map((r) => <li>{r.message}</li>)
  return <div className='t-text-input'>
          <div className="t-label">Infeasibility reasons</div> 
          <ul>{infeasibility_reasons}</ul>
        </div>
}